export { default, getStaticProps } from 'containers/IndexPage/IndexPage';
